import WildAppResource from "./WildAppResource";
import OrderAppResource from './OrderAppResource';
import SellerAppResource from './SellerAppResource';

class OrderSellerAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'order-seller';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'order-sellers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'signedAt',
            'invitationReminderLastSentAt',
            'invitationLastSentAt',
            'orderUuid',
            'sellerUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            order: OrderAppResource,
            seller: SellerAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            order: 'order_uuid',
            seller: 'seller_uuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            orderUuid: {
                type: 'string',
            },
            sellerUuid: {
                type: 'string',
            },
        };
    }

}

export default OrderSellerAppResource;
